import { DeliveryState, DeliveryResponseProps } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import { getDeliverySetting, createDeliverySetting } from "./deliverySettingsServices";

export const initialState: DeliveryState = {
  data: {} as DeliveryResponseProps,
  status: "loading",
  error: {},
};

export const DeliverySlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeliverySetting.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getDeliverySetting.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status;
          state.error = action.payload.error;
        }
      })
      .addCase(getDeliverySetting.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error;
      })
      .addCase(createDeliverySetting.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createDeliverySetting.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status;
          state.error = action.payload.error;
        }
      })
      .addCase(createDeliverySetting.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error;
      });
  },
});

export const DeliveryReducer = DeliverySlice.reducer;
